import { createSlice } from '@reduxjs/toolkit';
import ArcadaApiService from 'helpers/service/arcadaApiService';
import { FormatErrorResponse } from 'utils/formatErrorResponse';
import { dispatch } from '../store';

import { slice as globalNotificationSlice } from './globalNotifications';
import { TABLE_ROWS_COUNT_OPTIONS_MAX } from '../../utils/table';

const initialState = {
  isLoading: false,
  noResidents: null,
  error: null,
};

const slice = createSlice({
  name: 'noResident',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    getEntitiesSuccess(state, action) {
      state.isLoading = false;
      state.noResidents = action.payload;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

export function getNoResidents(
  skip = 0,
  take = TABLE_ROWS_COUNT_OPTIONS_MAX[0],
  search,
  order = 1,
  ordering = 'first_name'
) {
  const data = { skip, take, ordering, ordering_desc: order };

  if (search) data.search = search.trim();

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await ArcadaApiService.noResident.getNoResidents(data);
      dispatch(slice.actions.getEntitiesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(globalNotificationSlice.actions.hasNotification(FormatErrorResponse(error)));
    }
  };
}
